import * as React from "react";
import "moment/locale/fr";
import { Link, RouteComponentProps, useParams } from "react-router-dom";
import { defaults } from "react-chartjs-2";
import { register } from "timeago.js";
import { localeENFunc } from "src/utils/timeago";
import withSession from "src/utils/withSession";
import * as SC from "../companies/Company_styled";
import { translate } from "src/utils/translate";
import Video from "src/components/Video";
register("en", localeENFunc);
defaults.global.defaultFontFamily = "Gelion";
import { useHistory } from "react-router-dom";
import { Inbox } from "react-feather";
import { File } from "react-feather";
import { IUserCompany } from "src/pages/companies/createCompany";
import { Row as RowBT, Col } from "react-bootstrap";
import loadable from "@loadable/component";
import Bank from "./bank";
import Documents from "./documents";

import { multipleQueries } from 'src/utils/graph/GraphExplorer';

const Tab = loadable(() => import("src/presentations/widgets/Tab"));

export type Cell = string | number | undefined;

export interface Row {
  statusCode: number;
  value: string;
  type: string;
}
interface PropsInterface extends RouteComponentProps<{}> {
  session: any;
}

export interface IcompaniesRows {
  name: string;
  description: string;
  task: string;
  logoURL: string;
  color: string;
  id: string;
  companyUsers: IUserCompany[];
}

const CompanyDetail = (props: PropsInterface) => {
  const [showEC, setshowEC] = React.useState(false);
  const [showBalise, setshowBalise] = React.useState(false);
  const [showMarketplace, setshowMarketplace] = React.useState(false);
  const [activeTabIndex, setActiveTabIndex] = React.useState<number>(0);
  const { companyId, language }: any = useParams();
  const history = useHistory();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [company, setCompany] = React.useState({ folderNumber: '', name: '' });

  React.useEffect(() => {
    manageTab();
    getData();
  }, []);

  const getData = async () => {
    setLoading(true)
    const result: any = await multipleQueries([
      {
        type: "findOne",
        target: 'Company',
        alias: 'row',
        id: companyId,
        output: {
          id: true,
          name: true,
          accessToken: true,
          folderNumber: true,
          cabinet: {
            id: true,
            name: true
          },
        },
      }
    ]);

    setCompany(result.row)
    setLoading(false)
  }
  const manageTab = () => {
    switch (history.location.pathname.split("/")[4]) {
      case "banks":
        setActiveTabIndex(0);
        break;
      case "documents":
        setActiveTabIndex(1);
        break;
    }
  };

  const onChangeTab = (tabIndex: number) => {
    console.log("tabIndex", tabIndex);
    setActiveTabIndex(tabIndex);
    switch (tabIndex) {
      case 0:
        history.push(`/${language}/companies/${companyId}/banks`);
        break;
      case 1:
        history.push(`/${language}/companies/${companyId}/documents`);
        break;
    }
  };

  const renderFilters = () => (
    <RowBT>
      <Col md={12}>
        <Tab
          icons={[
            <Inbox style={{ marginRight: 5 }} size={17} key={0} />,
            <File style={{ marginRight: 5 }} size={17} key={0} />,
          ]}
          datas={
            [
              `${translate(language, "Comptes bancaires")}`,
              `${translate(language, "Relevés bancaires PDF")}`,
            ] as string[]
          }
          active={activeTabIndex}
          hideBar={false}
          onChangeTab={onChangeTab}
        />
      </Col>
    </RowBT>
  );

  return (
    <SC.StyleCompany>
      <div className="companyWrap">
      <ol className="breadcrumb">
          <li>
            <Link to={`/${language}`}>Accueil</Link>
          </li>
          <li className="active">{activeTabIndex === 0 ? "Comptes" : "Documents"}</li>
        </ol>
        <h4 style={{ marginBottom: 30, marginLeft: 30 }}> { loading === true ? '-' : `${company?.folderNumber || ''} / ${company?.name || ''}`} </h4>
        <div className="company-tab">{renderFilters()}</div>
        {activeTabIndex === 0 ? <Bank /> : <Documents />}
      </div>
      <Video
        show={showEC}
        videoURL={"https://youtu.be/D-UyXkzHtiA"}
        setshow={setshowEC}
      />
      <Video
        show={showBalise}
        videoURL={"https://youtu.be/TNwDWZr5XQs"}
        setshow={setshowBalise}
      />
      <Video
        show={showMarketplace}
        videoURL={"https://youtu.be/6ZDiVQK20Yw"}
        setshow={setshowMarketplace}
      />
    </SC.StyleCompany>
  );
};

export default withSession(CompanyDetail);



// WEBPACK FOOTER //
// ./src/pages/company/index.tsx